import React from 'react'
import { Container } from './styles'
import logoImage from '../../assets/logo_plano_familia_300x-8.png'

const Logo: React.FC = () => {
  return <Container src={logoImage} alt="Ceres Logo" />
}

export default Logo
